// extracted by mini-css-extract-plugin
module.exports = {"input-container":"DrawerAlertSelect_input-container__Peo9Q","required":"DrawerAlertSelect_required__6YXUf","placeholder":"DrawerAlertSelect_placeholder__xbWyP"};